import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import AuthService from '../services/auth.service';
import packageJson from '../../package.json';

const { Title, Text } = Typography;

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const history = useHistory();

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError('');
    try {
      const response = await AuthService.login(email, password);
      const userRole = response.data && response.data.role;

      if (userRole === 'DRIVER') {
        history.push('/driver');
      } else {
        history.push('/');
      }
      window.location.reload();
    } catch (err) {
      const message = (err.response && err.response.data && err.response.data.message)
        || 'Error al iniciar sesión. Verifique sus credenciales.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card" bordered={false}>
        <div className="login-header">
          <Title level={3} style={{ margin: 0 }}>Delivery</Title>
          <Text type="secondary">Sistema de Rutas de Delivery</Text>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={() => setError('')}
            style={{ marginBottom: 24 }}
          />
        )}

        <Form layout="vertical" onFinish={handleLogin} autoComplete="off">
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Ingrese su email' },
              { type: 'email', message: 'Email inválido' },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="correo@ejemplo.com"
              size="large"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Ingrese su contraseña' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Contraseña"
              size="large"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              block
            >
              Ingresar
            </Button>
          </Form.Item>
        </Form>

        <div className="login-version">v{packageJson.version}</div>
      </Card>
    </div>
  );
}

export default Login;
